/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SENSYN ID API
 * - ユーザー、組織情報の取得API
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  GetUsersInOwnOrganizationParams,
  UserListResponse,
  UserMeResponse,
  UserPresignedUrlResponse
} from '../model';

import getUsersInOwnOrganizationMutator from '../../../mutators/sensyn-id-instance';
import getUserMeMutator from '../../../mutators/sensyn-id-instance';
import generatePresignedUrlMutator from '../../../mutators/sensyn-id-instance';



  /**
 * - 所属組織のユーザー一覧を取得する
 * @summary getUsersInOwnOrganization
 */
export const getUsersInOwnOrganization = (
    params?: GetUsersInOwnOrganizationParams,
 ) => {
      return getUsersInOwnOrganizationMutator<UserListResponse>(
      {url: `/users/`, method: 'GET',
        params
    },
      );
    }
  /**
 * - ログインユーザー情報を取得する
 * @summary getUserMe
 */
export const getUserMe = (

 ) => {
      return getUserMeMutator<UserMeResponse>(
      {url: `/users/me/`, method: 'GET'
    },
      );
    }
  /**
 * - ログインユーザーにログイン不要で利用できるURL発行(対応ページのみ)
 * @summary generatePresignedUrl
 */
export const generatePresignedUrl = (

 ) => {
      return generatePresignedUrlMutator<UserPresignedUrlResponse>(
      {url: `/users/presigned-url`, method: 'POST'
    },
      );
    }
  export type GetUsersInOwnOrganizationResult = NonNullable<Awaited<ReturnType<typeof getUsersInOwnOrganization>>>
export type GetUserMeResult = NonNullable<Awaited<ReturnType<typeof getUserMe>>>
export type GeneratePresignedUrlResult = NonNullable<Awaited<ReturnType<typeof generatePresignedUrl>>>
